/**
 * QuestionMarkBubble / Help icon — speech bubble with `?` and a tail in the lower-left.
 * Uses `currentColor` for stroke.
 */
export function QuestionMarkBubble({ className, width = '1em', height = '1em', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      {/* Speech bubble (circle + lower-left tail) as a single closed path */}
      <path d="M 7.6 20.4 L 2.5 21.5 L 3.6 16.4 A 9.5 9.5 0 1 1 7.6 20.4 Z" />
      {/* The `?` glyph, centered in the bubble */}
      <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  )
}